import React from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../../../common/types/FileRecordStatus";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";

interface EditingStatusDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

export const EditingStatusDialog = ({ isOpen, onClose }: EditingStatusDialogProps): JSX.Element => {
    const { changeFileRecordToEditing } = useFileRecordApi();

    const { setStatus, fileRecordDetails } = useFileRecordDetailsState();

    const handleConfirmation = async () => {
        await changeFileRecordToEditing({ fileRecordId: fileRecordDetails.id });

        setStatus(FileRecordStatus.Editing);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Change status to editing"
            text="Are you sure you want to update given file record to editing?"
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
